function RoleBasedRoute({ children }) {
    return children;
}

export default RoleBasedRoute;